import Card from '../Card'

export default class Gold extends Card {
  name = 'Gold'

  constructor(public value: number) {
    super()
  }

  pick(picker = this.board!.hero.card) {
    if (!super.pick(picker)) return false

    const hero = this.board!.hero
    const movePickerHere = () => picker.moveTo(this.location!)

    if (picker === hero.card)
      hero.increaseGold(this.value)
    else picker.loot = this.moveTo()
    movePickerHere()
    this.drawCards()

    return true
  }

  clone(): Card {
    return new Gold(this.value)
  }
}
